import React, { useEffect, useState } from "react";
import "./index.scss";

interface ChristmasSantaSlideProps {
  message?: string;
  showFrequency?: number;
  animationDuration?: number;
  onAnimationComplete?: () => void;
}

export function ChristmasSantaSlide({
  message = "🎄 Feliz Natal! Resgate seus presentes! 🎅",
  showFrequency = 45000,
  animationDuration = 37500, // 1.5 loops x 25s = 3 passadas
  onAnimationComplete,
}: ChristmasSantaSlideProps) {
  const [showSanta, setShowSanta] = useState(false);
  const [hasCompleted, setHasCompleted] = useState(false);
  const [hasFocused, setHasFocused] = useState(false);

  useEffect(() => {
    if (hasCompleted) return;

    setShowSanta(true);

    // Após 37.5s (3 passadas), para e chama callback
    const timer = setTimeout(() => {
      setShowSanta(false);
      setHasCompleted(true);
      if (onAnimationComplete) {
        onAnimationComplete();
      }
    }, animationDuration);

    return () => clearTimeout(timer);
  }, [animationDuration, onAnimationComplete, hasCompleted]);

  useEffect(() => {
    if (!showSanta || hasFocused) return;
    const target = document.getElementById("double-points-button") as HTMLElement | null;
    if (target) {
      // Aguarda anúncio do banner antes de levar foco para a ação - APENAS na primeira vez
      setTimeout(() => {
        target.focus();
        setHasFocused(true);
      }, 1200);
    }
  }, [showSanta, hasFocused]);

  if (!showSanta) return null;

  return (
    <div className="christmas-santa-slide-container" aria-hidden="true">
      {showSanta && (
        <div className="sleigh-santa-scene">
          {/* Banner com mensagem sendo puxado atrás - DEVE VIR PRIMEIRO NO DOM */}
          <div className="christmas-message-banner">
            {/* Banner - Com wrapper para contra-espelhar */}
            <div className="banner-unflip">
              <div className="banner-wrapper">
                <div className="banner-pole banner-pole-left"></div>
                <div className="banner-content">
                  {message}
                  {/* Selo de cera vermelho com estrela */}
                  <div className="wax-seal"></div>
                </div>
                <div className="banner-pole banner-pole-right"></div>
              </div>
            </div>

            {/* Corda do banner ao trenó */}
            <div className="banner-rope"></div>
          </div>

          <div className="sleigh-santa">
            {/* Rena */}
            <div className="reindeer">
              <div className="reindeer__face">
                <div className="reindeer__ear"></div>
                <div className="reindeer__horn reindeer__horn--right"></div>
                <div className="reindeer__horn reindeer__horn--left"></div>
              </div>
              <div className="reindeer__body">
                <div className="reindeer__foot reindeer__foot--front">
                  <div className="reindeer__foot-inner"></div>
                </div>
                <div className="reindeer__foot reindeer__foot--front reindeer__foot--inside">
                  <div className="reindeer__foot-inner"></div>
                </div>
                <div className="reindeer__foot reindeer__foot--back">
                  <div className="reindeer__foot-inner"></div>
                </div>
                <div className="reindeer__foot reindeer__foot--back reindeer__foot--inside">
                  <div className="reindeer__foot-inner"></div>
                </div>
                <div className="reindeer__tail"></div>
                <div className="reindeer__spots"></div>
              </div>
            </div>

            {/* Cordas */}
            <div className="lead">
              <div className="lead-inner"></div>
            </div>
            <div className="lead lead--back">
              <div className="lead-inner"></div>
            </div>

            {/* Trenó */}
            <div className="santa santa--sleigh">
              <div className="santa__hat">
                <div className="santa__hat-part"></div>
                <div className="santa__hat-part"></div>
              </div>
              <div className="santa__face">
                <div className="santa__eyebrows santa__eyebrows--right"></div>
                <div className="santa__eyebrows santa__eyebrows--left"></div>
                <div className="santa__eye santa__eye--right"></div>
                <div className="santa__eye santa__eye--left"></div>
                <div className="santa__nose"></div>
                <div className="santa__cheek santa__cheek--right"></div>
                <div className="santa__cheek santa__cheek--left"></div>
                <div className="santa__beard">
                  <div className="santa__beard-part"></div>
                  <div className="santa__beard-part"></div>
                  <div className="santa__beard-part"></div>
                </div>
              </div>
              <div className="santa__body">
                <div className="santa__body-top"></div>
                <div className="santa__hand santa__hand--left">
                  <div className="santa__hand-inner"></div>
                </div>
                <div className="santa__hand santa__hand--right"></div>
              </div>
            </div>

            <div className="sleigh-feet"></div>
            <div className="particles"></div>
          </div>
        </div>
      )}
    </div>
  );
}
